import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService } from '@app/core';
import { Category } from '@core/model/category.model';
import Swal from 'sweetalert2';
import { Paginated } from '@app/core/model/paginated.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {
  categoryForm: FormGroup;
  categories: Category[];
  Category: any = {};
  estado: boolean;
  idCategory: string;

  pager = {};
  pageOfItems: any = [];

  productos: Paginated;
  private searchTermStream = new Subject<string>();
  currentSearchTerm: string = null;
  private closeResult: string;

  constructor(
    private formBuilder: FormBuilder,
    private categoryService: CategoryService
  ) {}

  ngOnInit() {
    this.createForm();
    this.listCategories();
  }

  createForm() {
    this.categoryForm = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
  }

  listCategories() {
    this.categoryService.getAll().subscribe(
      data => {
        this.categories = data;
        //  console.log(data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  registerCategory() {
    //  console.log(this.categoryForm.value);
    this.Category.nombre = this.categoryForm.value.nombre;
    this.Category.descripcion = this.categoryForm.value.descripcion;
    // console.log(this.Category);
    if (this.estado === true) {
      this.categoryService.update(this.idCategory, this.Category).subscribe(
        data => {
          Swal.fire(data);
          this.listCategories();
          this.categoryForm.reset();
          this.estado = false;
        },
        error1 => {
          Swal.fire(error1.error);
        }
      );
    } else {
      this.categoryService.create(this.Category).subscribe(
        data => {
          // alert('Fue creado satisfactoriamente');
          Swal.fire(data);
          this.listCategories();
          this.categoryForm.reset();
        },
        error => {
          Swal.fire(error.error);
        }
      );
    }
  }

  enableCategory(id: number) {
    this.categoryService.enableCategory(id).subscribe(
      data => {
        this.listCategories();
      },
      error => {
        console.log(error.error);
      }
    );
  }

  editCategory(categoria_id: string) {
    this.idCategory = categoria_id;
    this.estado = true;
    this.categoryService.getById(categoria_id).subscribe(
      data => {
        // console.log(data);
        this.categoryForm.setValue({
          nombre: data.nombre,
          descripcion: data.descripcion
        });
      },
      error1 => console.log(error1)
    );
  }
}
